import { Component, AfterContentInit, OnDestroy, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { IBakery, ngHelper } from '@cakeiteasy/web-utils';

import { cartHelper, getActualDeliveryPrice } from '../../../cart';
import { UI_DELIVERY_OPTIONS } from '../../../cart/constants/common';
import { ICart } from '../../../cart/models/cart/i-cart';
import { ICakeCartLine } from '../../../cart/models/cart/i-cake-cart-line';
import { ICakeCartSourceMeta } from '../../../cart/models/cart/i-cake-cart-source-meta';
import { IDeliveryToDoor, IPickupDelivery } from '../../../cart/models/delivery';

@Component({
  standalone: false,
  selector: 'mobile-cart',
  templateUrl: './mobile-cart.component.html',
  styleUrls: ['./mobile-cart.component.scss']
})
export class MobileCartComponent implements OnChanges, AfterContentInit, OnDestroy {
  @Input() cart: ICart;
  @Input() fillBackground: boolean;

  @Output() public onEditOrdered = new EventEmitter<{
    productTypeId: number,
    productTypeName: string,
    orderLineBuilderId?: string,
    source: string,
    sourceMeta: ICakeCartSourceMeta,
    bakeryName?: string,
  }>();

  @Output() public onRemoveProduct = new EventEmitter<ICakeCartLine>();
  @Output() public onCountUpdate = new EventEmitter<ICakeCartLine>();
  @Output() public onContinue = new EventEmitter<void>();
  @Output() public onAddMoreClick = new EventEmitter<void>();
  @Output() public onDeliveryEdit = new EventEmitter<string>();
  @Output() public onClose = new EventEmitter<any>();
  @Output() public onClear = new EventEmitter<void>();

  public total: number;
  public currency: string;
  public orderLines: ICakeCartLine[];
  public bakery: IBakery;

  public delivery: IPickupDelivery | IDeliveryToDoor;
  public deliveryPrice: number;
  public count: number;

  public DELIVERY_OPTIONS = UI_DELIVERY_OPTIONS;

  ngAfterContentInit() {
    setTimeout(() => {
      window.scroll(0, 0);
    });
  }

  ngOnDestroy() {
    window.scroll(0, 0);
  }

  ngOnChanges(changes: SimpleChanges) {
    ngHelper.ifChanged(changes, 'cart', (cart: ICart) => {
      if (cart) {
        this._init(cart);
      }
    });
  }

  public editOrderLine(line: ICakeCartLine) {
    this.onEditOrdered.emit({
      productTypeId: line.parentType && line.orderLineBuilderId ? line.parentType : line.product.type.id,
      productTypeName: line.name,
      orderLineBuilderId: line.orderLineBuilderId,
      source: line.source,
      sourceMeta: line.sourceMeta,
      bakeryName: this.bakery.name,
    });
  }

  public removeProduct(line: ICakeCartLine) {
    this.onRemoveProduct.emit(line);
  }

  public countUpdated(count: number, line: ICakeCartLine) {
    line.count = count;
    this.onCountUpdate.emit(line);
  }

  private _init(cart: ICart) {
    const { bakery, lines, delivery } = cart;
    this.bakery = bakery;
    this.delivery = delivery;
    this.deliveryPrice = delivery && getActualDeliveryPrice(delivery) || 0;
    this.orderLines = [...lines as ICakeCartLine[]];
    this.currency = bakery && bakery.country.currencySymbol;
    this.total = cart.totalPrice;
    this.count = cartHelper.getQuantityFromOrderLines(cart.lines);
  }
}
